import { UserManagerSettings, WebStorageStateStore } from "oidc-client-ts";

let portalUrl = window.location.origin;

export const OidcConfig: UserManagerSettings = {
  client_id: "S5E-SPA-PKCE",
  redirect_uri: `${portalUrl}/auth/callback`,
  authority: "/authority",
  response_type: "code",
  post_logout_redirect_uri: `${portalUrl}`,
  scope: "openid profile email graphql-gateway master-data communication personal-data reporting offline_access",
  silent_redirect_uri: `${portalUrl}/auth/silent_callback`,
  automaticSilentRenew: true,
  loadUserInfo: true,
  userStore: new WebStorageStateStore({ prefix: "S5E-SPA-PKCE",
                                        store: localStorage 
                                      }),
  prompt: "login"
};
